import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoginBox from '../components/LoginBox';

import { login, loginWithGoogle } from '../actions/Login';


class LoginContainer extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGoogle = this.handleGoogle.bind(this);
    }

    handleSubmit(form) {
        this.props.dispatch(login(form));
    }

    handleGoogle(credential) {
        this.props.dispatch(loginWithGoogle(credential));
    }

    render() {
        return (
            <LoginBox onSubmit={this.handleSubmit} onGoogle={this.handleGoogle}/>
        )
    }
}

function mapStateToProps(state) {
    return state;
}

export default connect(mapStateToProps)(LoginContainer);